const LISTAR_DADOS = (state, payload) => {
    state.items = payload
}

const LISTAR_DADOS_TIPOS_AGINGS = (state, payload) => {
    state.tipoAgings = payload
}

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}

const INSERIR_WORKFLOW_SELECIONADO = (state,  payload) => {
  state.selecionado = payload
}

export {
    LISTAR_DADOS,
    LISTAR_DADOS_TIPOS_AGINGS,
    CARREGANDO,
    INSERIR_WORKFLOW_SELECIONADO
}